import { Component } from '@angular/core';
import { PlatformService } from '@app/services/platform.service';
import SwiperCore, { SwiperOptions, Navigation, Pagination, Autoplay } from 'swiper';

SwiperCore.use([Navigation, Pagination, Autoplay])

declare var $: any;
declare function equalHeightGroup(): any;

@Component({
  selector: 'swiper-employer-testimony',
  templateUrl: './swiper-employer-testimony.component.html',
  styleUrls: ['./swiper-employer-testimony.component.css']
})
export class SwiperEmployerTestimonyComponent {

  public swiperConfig: SwiperOptions | undefined = undefined;

  constructor(private platformService: PlatformService) {
    if (!platformService.isPlatformBrowser)
      return;

    this.swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 450,
      autoplay: false,
      loop: false,
      grabCursor: true,
      preloadImages: false,
      lazy: false,
      pagination: {
        el: '#swiper-employer-testimony',
        clickable: true,
      },
      navigation: {
        nextEl: '#swiper-employer-testimony-next',
        prevEl: '#swiper-employer-testimony-prev',
      },
      breakpoints: {
        992: {
          slidesPerView: 2
        }
      }
    }
  }
  
  onSwiper(event:any)
  {
    $('.equal-height-group').each(equalHeightGroup);
    $(window).resize(function () {
      $('.equal-height-group').each(equalHeightGroup);
    });
  }

}
